import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import desktopImage from '../../../assets/images/backoffice/superSales/superSales.png';
import mobileImage from '../../../assets/images/backoffice/superSales/superSalesMobile.png';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import Spinner from '../../../components/common/Spinner';
import { getUserTickets } from '../../../slices/auth-slice';
import { H3, P1, P2 } from '../../../styles/FontStyles';
import { Button, Flexed, PageTitle } from '../../../styles/GlobalComponents';
import { color, lightTheme } from '../../../styles/GlobalStyles';
import { Desktop, Mobile } from '../../Kyc/KycStyled';
import {
  getSuperSalesLicences,
  setPurchaseCardStep
} from '../Marketplace.actions';
import { StakingHubDetailsStyled } from '../Marketplace.styled';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

import { PurchaseSteps } from '../Maeketplace.types';

export const SuperSales = () => {
  const dispatch = useDispatch();

  const { loading, hubs, subscriptions, subscriptionBundle } = useSelector(
    (state) => state.marketplace
  );

  useEffect(() => {
    dispatch(getSuperSalesLicences());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
    dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_METHOD }));
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Desktop>
        <section style={{ position: 'relative' }}>
          <img src={desktopImage} alt='trading' style={{ width: '100%' }} />
          {/* <CountdownComponent timestamp={timestamp} /> */}
        </section>
      </Desktop>

      <Mobile>
        <section style={{ position: 'relative' }}>
          <img src={mobileImage} alt='trading' style={{ width: '100%' }} />
        </section>
      </Mobile>

      <P1 mb='20' mt='40'>
        Ready to take your sales to the next level?
      </P1>
      <P1 mb='20'>
        Step into the future of entrepreneurship with Super Sales – the ultimate
        platform designed to help you build, grow, and scale your business
        faster than ever. With powerful tools, smart automation, and a proven
        system, Super Sales turns your ambition into results.
      </P1>
      <P1 mb='40'>
        Join today and start creating income, impact, and independence!
      </P1>

      <PageTitle>Pre-Sale PROMOTION - Special discounted prices!</PageTitle>
      <P2 color={lightTheme.colors.neutral500}>
        *You are eligible to receive the tickets for pools if you have a paid
        Back-office subscription.
      </P2>

      <Flexed mt='40' rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          {hubs?.map((hub, index) => {
            const {
              id,
              imageUrl,
              name,
              price,
              priceToShow,
              subtitle,
              tickets,
              vatPrice,
              feePrice,
              type
            } = hub;

            return (
              <Hub
                id={id}
                key={index}
                image={imageUrl}
                showTickets={false}
                title={name}
                price={price}
                priceToShow={priceToShow}
                subtitle={subtitle}
                tickets={tickets}
                onClick={() => handleSeeDetails(hub)}
                selected={selectedHub?.price === price}
                vatPrice={vatPrice}
                feePrice={feePrice}
                type={type}
                button={
                  <Button
                    w='200px'
                    wSM='100%'
                    onClick={() => handleSelectPackage(hub)}
                    negative={selectedHub?.price !== price}>
                    Select License
                  </Button>
                }
                stakingHubDetails={<StakingHubDetails hub={hub} />}
              />
            );
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter>
              {selectedHub?.price &&
                hubs?.map((hub, i) => {
                  if (hub?.price === selectedHub?.price) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}

              {selectedHub?.price &&
                subscriptions?.map((hub, i) => {
                  if (hub?.price === selectedHub?.price) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
              {selectedHub?.price &&
                subscriptionBundle?.map((hub, i) => {
                  if (hub?.price === selectedHub?.price) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
            </AnimatePresence>
          </div>
        </Flexed>
      </Flexed>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};

export const StakingHubDetails = ({ hub }) => {
  return (
    <div>
      <P1 semiBold color={color.colors.neutral500} mb='12'>
        License Benefits
      </P1>
      {hub?.benefits?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit} />
        </div>
      ))}
    </div>
  );
};
